import { Mask } from '../mask.interface';
export class PhoneModel implements Mask {

 private phoneMask = [/[0-9]/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  getMaskRule(): (string | RegExp)[] | Function | boolean {
    return this.phoneMask;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/phone.model.ts